import React from 'react';
import './Testimonials.css';
import Image3 from '../../assets/sneha.jpg';
import Image4 from '../../assets/rohit.jpg';

import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

const Testimonials = () => {
  const data = [

    {
      id: 1,
      image: Image3,
      title: "Sneha Verma",
      subtitle: "Product Manager @ Butterfly",
      comment:
        "It was a pleasure working with Abhay on the Butterfly real estate project. His design instincts, Figma skills, and collaborative approach made the project seamless and visually stunning!",
    },
    {
      id: 2,
      image: Image4,
      title: "Rohit Sharma",
      subtitle: "Founder @ ToDo",
      comment:
        "Abhay worked with us on an educational app project and delivered beyond expectations. His UI/UX decisions were always backed with logic and user empathy. Truly reliable and creative!",
    },
  ];

  return (
    <section className="testimonials container section">
      <h2 className="section__title">Testimonials</h2>

      <Swiper
        className="testimonial__container grid"
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        grabCursor={true}
        pagination={{ clickable: true }}
      >
        {data.map(({ id, image, title, subtitle, comment }) => (
          <SwiperSlide className="testimonial__item" key={id}>
            <div className="thumb">
              <img src={image} alt={title} />
            </div>
            <h3 className="testimonial__title">{title}</h3>
            <span className="subtitle">{subtitle}</span>
            <div className="comment">{comment}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
